import { render } from "./ImgBlock.vue?vue&type=template&id=53d8518c&scoped=true"
import script from "./ImgBlock.vue?vue&type=script&lang=js"
export * from "./ImgBlock.vue?vue&type=script&lang=js"

import "./ImgBlock.vue?vue&type=style&index=0&id=53d8518c&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d8518c"]])

export default __exports__